export default __webpack_public_path__ + "static/media/2199.417e17e0.png";